import { apiClient } from '@/shared/api';
import { RequestBodyParams } from '@/shared/config';

import { ProductCatalogResponse } from '../config';

export async function getProductCatalogData(
  slug: string,
  params?: RequestBodyParams,
): Promise<ProductCatalogResponse> {
  return await apiClient(`product-search/${slug}`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
}
